// extracted by mini-css-extract-plugin
module.exports = {"home":"Index_home_2RQC-","inside-link":"Index_inside-link_3qA-8","SectionContact":"Index_SectionContact_1h_8H","SectionBrand":"Index_SectionBrand_2O9UO"};